module.exports = __webpack_public_path__ + "storeCodeWithoutHeader.7088773dd99c0bd88ffc2365e2b0f326.csv";